module.exports = __webpack_public_path__ + "img/case22.caca4b31.png";